import { ReactEditor } from 'slate-react';
import { Range, Node, Editor } from 'slate';
import { PARAGRAPH_TOGGLE } from './types';

export const withParagraphToggle =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { deleteBackward, deleteForward } = editor;

    editor.deleteBackward = (unit) => {
      if (isEmptyText(editor) || isParagraphStart(editor)) {
        return;
      }
      deleteBackward(unit);
    };

    editor.deleteForward = (unit) => {
      if (isEmptyText(editor)) {
        return;
      }

      deleteForward(unit);
    };

    return editor;
  };

function isEmptyText(editor) {
  if (editor.selection && Range.isCollapsed(editor.selection)) {
    const entry = Editor.above(editor, {
      at: editor.selection.anchor.path,
      match: (n: any) => n.type === PARAGRAPH_TOGGLE,
    });
    if (entry) {
      const [paragraphToggle] = entry;
      if (Node.string(paragraphToggle) === '') {
        return true;
      }
    }
  }

  return false;
}

/**
 *
 *  children = [
 *    {
 *      type: ELEMENT_PARAGRAPH,
 *      children: [
 *        {
 *          text,
 *        },
 *      ],
 *    },
 *  ],
 */
const firstChildrenPath = [0, 0];

function isParagraphStart(editor) {
  if (editor.selection && Range.isCollapsed(editor.selection)) {
    const entry = Editor.above(editor, {
      at: editor.selection.anchor.path,
      match: (n: any) => n.type === PARAGRAPH_TOGGLE,
    });

    if (entry) {
      const [, paragraphPath] = entry;
      if (
        editor.selection.anchor.path.join('') ===
          paragraphPath.concat(firstChildrenPath).join('') &&
        editor.selection.anchor.offset === 0
      )
        return true;
    }
  }

  return false;
}
